import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ReturnManifestApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.RETURN_MANIFEST);
  }

  getShipmentsOfReturnManifest(
    returnManifestId,
    params = new URLSearchParams(),
  ) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${returnManifestId}/shipments/?${queryString}`
      : `${this.getResourceUrl()}${returnManifestId}/shipments/`;

    return this.httpClient.get(url);
  }

  addShipmentToReturnManifest(returnManifestId, barcode) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${returnManifestId}/shipment-add/`,
      { barcode: barcode },
    );
  }

  removeShipmentFromReturnManifest(returnManifestId, shipmentId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${returnManifestId}/shipment-remove/`,
      {
        shipment: shipmentId,
      },
    );
  }

  closeReturnManifest(returnManifestId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${returnManifestId}/close/`,
      {},
    );
  }

  discardReturnManifest(returnManifestId) {
    return this.httpClient.delete(
      `${this.getResourceUrl()}${returnManifestId}/`,
    );
  }

  updateReturnManifestShipment(shipmentId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${shipmentId}/update/`,
      data,
    );
  }

  exportReturnManifest(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }
}

export default new ReturnManifestApi();
